import { render, staticRenderFns } from "./selfhandle-list.vue?vue&type=template&id=3b982738&scoped=true"
import script from "./selfhandle-list.vue?vue&type=script&lang=js"
export * from "./selfhandle-list.vue?vue&type=script&lang=js"
import style0 from "./selfhandle-list.vue?vue&type=style&index=0&id=3b982738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b982738",
  null
  
)

export default component.exports